<script setup>
    import { SEED_SPEC_VALUES } from '~/constants';

    const props = defineProps(['filterData','normalizeCheckboxArrays','resetPage']);
    const router = useRouter();
    const route = useRoute();
    
    // Собираем обьект для хранения значений
    const filters = props.filterData.reduce((acc, item) => {
        const defaultValue = item.type != 'radio' ? [] : '';

        if (item.type == 'search') {
            const value = item.values.find(it => it.id == route.query[item.name]);
            acc[item.name] = value ? value.id : defaultValue;
        } else {
            const value=route.query[item.name] ?? defaultValue;
            acc[item.name]=props.normalizeCheckboxArrays && item.type!=='radio' ? (Array.isArray(value)?[...value]:value===''?[]:[value]) : value;
        }

        return acc;
    }, reactive({}));
    
    // При изменении значения фильтра вызываем событие
    // Object.fromEntries(route.query) - достать параметры
    // emits('update:filter', data);
    watch(filters, (data) => {
        const query={...route.query,...data};
        if(props.resetPage)delete query.page;
        router.replace({query});
    });
</script>

<template>
    <!--
        Множественный выбор это всегда чекбоксы
        Единичный выбор:
            Если только 2 варинта это радиокнопка
            Больше 2х вариантов селект
    -->
    <template v-for="data in filterData">    
        <b class="block my-2">{{data.label}}</b>
        <div :class="['flex-shrink-0 grid gap-1', data.class]">
            <template v-if="data.type == 'search'">
                <el-select
                    v-model="filters[data.name]"
					placeholder="Выберите город"
					no-data-text="Нет городов"
					no-match-text="Нет подходящих городов"
					filterable
				>
					<el-option
                        class="flex justify-between"
						v-for="item in data.values"
						:key="item.id"
						:label="item.name"
						:value="item.id"
					>
                        <span>{{ item.name }}</span>
                        <span class="text-slate-400">{{ item.region.country.name }}</span>
                    </el-option>
				</el-select>
            </template>
            <label v-else class="flex gap-2 items-center text-black/l text-sm" v-for="(value,key) in data.values" :key="value">
                <!-- Если у нас массив то используем в качестве значения, значение элемента, если обьект то ключ/указатель -->
                <!-- TODO может быть вариант что данные выглядят как массив с обьектами { label: value } -->
                <input :type="data.type ?? 'checkbox'" :name="data.name" :value="Array.isArray(data.values) ? value : key" v-model="filters[data.name]">
                <slot :name="data.slot" v-bind="{ value }">
                    {{SEED_SPEC_VALUES[value] ?? value}}
                </slot>
            </label>	
        </div>
    </template>
</template>